import { marqueeFlash, hotRank } from "@/mocks/home";

export default function Hero() {
  const marqueeItems = [...marqueeFlash, ...marqueeFlash];
  return (
    <section id="top" className="bg-background-50">
      {/* 实时滚动条 */}
      <div className="border-b border-background-200 bg-foreground-950">
        <div className="mx-auto flex h-11 w-full max-w-7xl items-center gap-3 overflow-hidden px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
            <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-background-50"></span>
            实时播报
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track text-sm text-background-100">
              {marqueeItems.map((m, i) => (
                <span key={i} className="mx-6 inline-flex items-center gap-2 whitespace-nowrap">
                  <span className="text-accent-400">•</span>
                  {m}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 whitespace-nowrap text-xs text-background-400 sm:block">
            更新于 21:02
          </span>
        </div>
      </div>

      {/* 首屏 */}
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 pb-14 pt-10 md:px-6 lg:grid-cols-12 lg:gap-8 lg:pt-16">
        <div className="fade-up lg:col-span-7">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-flashlight-line"></i>
            一手消息 · 实时更新频道
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            今天吃瓜
            <br />
            不错过任何一条
            <span className="relative whitespace-nowrap text-primary-600">
              新鲜爆料
              <span className="absolute -bottom-1 left-0 h-1 w-full rounded-full bg-accent-400"></span>
            </span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            滚动播报最新瓜料与实时动态，娱乐八卦、剧集综艺、音乐热点一手速览。吃瓜最新进展、实时汇总持续刷新，随时点开随时有料。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#fresh"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-refresh-line mr-1.5"></i>看看今日更新
            </a>
            <a
              href="#feed"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-center text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
            >
              查看实时热榜
            </a>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4">
            {[
              { n: "24h", l: "不间断刷新" },
              { n: "99+", l: "今日热议话题" },
              { n: "10w+", l: "每周活跃吃瓜人" },
            ].map((s) => (
              <div key={s.l} className="rounded-lg bg-secondary-100/70 px-3 py-3 text-center">
                <dt className="font-heading text-xl font-black text-primary-600 md:text-2xl">{s.n}</dt>
                <dd className="mt-1 text-xs text-foreground-600 md:text-sm">{s.l}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 右栏 热榜卡片 */}
        <div className="fade-up lg:col-span-5" style={{ animationDelay: "0.1s" }}>
          <div className="overflow-hidden rounded-xl border border-background-200 bg-background-100">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-fire-fill"></i>
                </span>
                <h2 className="font-heading text-lg font-black text-foreground-950">实时热榜</h2>
              </div>
              <a href="#feed" className="whitespace-nowrap text-xs font-medium text-primary-600 hover:text-primary-700">
                查看全部 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <ol className="divide-y divide-background-200/70 px-5">
              {hotRank.slice(0, 5).map((h) => (
                <li key={h.rank}>
                  <a href="#fresh" className="group flex items-center gap-3 py-3">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black ${
                        h.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-foreground-700"
                      }`}
                    >
                      {h.rank}
                    </span>
                    <span className="flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                      {h.title}
                    </span>
                    <i
                      className={
                        h.up
                          ? "ri-arrow-up-line text-xs text-accent-600"
                          : h.down
                            ? "ri-arrow-down-line text-xs text-secondary-500"
                            : "ri-arrow-right-line text-xs text-foreground-400"
                      }
                    ></i>
                  </a>
                </li>
              ))}
            </ol>
            <div className="px-5 pb-4">
              <a
                href="#feed"
                className="flex items-center justify-center gap-1 rounded-md bg-secondary-100 px-4 py-2.5 text-xs font-semibold text-secondary-900 transition hover:bg-secondary-200"
              >
                展开完整榜单（共 10 条）
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}